import { CUBE_ID_CELL_STYLE, CUBE_ID_DISPLAY_STYLE } from './cubeTestReportDefaults';

const cubeIdInputStyle = {
  ...CUBE_ID_DISPLAY_STYLE,
  cursor: 'text',
};

const cellInputStyle = {
  width: '100%',
  minWidth: '80px',
  backgroundColor: 'white',
  textAlign: 'center',
  boxSizing: 'border-box',
};

function TableRowsAge({ rowsData, deleteTableRows, handletableChange }) {
  return rowsData.map((data, index) => {
    const { age, no_of_moulds, cube_id: cubeId, cured_place: curedPlace } = data;
    return (
      <tr key={index} className="text-center detailclass" id="after-this1">
        <td>
          <button type="button" className="btn btn-danger btn-sm" onClick={() => deleteTableRows(index)}>
            x
          </button>
        </td>
        <td>
          <input
            type="number"
            min="0"
            max="28"
            name="age"
            value={age}
            onChange={(evnt) => handletableChange(index, evnt)}
            style={cellInputStyle}
            className="form-control mandatory-form-control"
            autoComplete="off"
          />
        </td>
        <td>
          <input
            type="number"
            min="0"
            max="12"
            style={cellInputStyle}
            className="form-control mandatory-form-control"
            value={no_of_moulds}
            onChange={(evnt) => handletableChange(index, evnt)}
            name="no_of_moulds"
            required
            autoComplete="off"
          />
        </td>
        <td>
          <select
            name="cured_place"
            value={curedPlace || ''}
            onChange={(evnt) => handletableChange(index, evnt)}
            className="form-control mandatory-form-control browser-default custom-select"
            style={cellInputStyle}
            required
          >
            <option value="">Select</option>
            <option value="plant">Plant</option>
            <option value="site">Site</option>
          </select>
        </td>
        <td style={CUBE_ID_CELL_STYLE}>
          <input
            type="text"
            maxLength="20"
            style={cubeIdInputStyle}
            className="form-control"
            value={cubeId || ''}
            onChange={(evnt) => handletableChange(index, evnt)}
            name="cube_id"
            autoComplete="off"
            spellCheck={false}
            title={cubeId || 'Auto-generated from customer initials, grade and age. You can edit if needed.'}
          />
        </td>
      </tr>
    );
  });
}

export default TableRowsAge;
